export default __webpack_public_path__ + "static/media/404-portrait.0d989823.jpg";